import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { TableColumnModule } from './column/column.module';
import { TableHeaderModule } from './header/header.module';
import { RowModule } from './row/row.module';
import { TableComponent } from './table/table.component';
import { TableRowEditAddFactory } from './ui-grid-api/row-edit-add.factory';
import { TableRowEditAutoSaveFactory } from './ui-grid-api/row-edit-auto-save.factory';
import { TableRowEditDeleteFactory } from './ui-grid-api/row-edit-delete.factory';
import { TableRowEditFactory } from './ui-grid-api/row-edit.factory';
import { TableRowFooterAggregationFactory } from './ui-grid-api/row-footer-aggregation.factory';
import { ColumnFilterFactory } from 'src/ag-grid-wrapper/ui-grid-api/column-filter.factory';

/*
The below change is how AG Grid officially says to refactor for v28.  However, it results in the following error:
"Module '"ag-grid-enterprise"' has no exported member 'AllEnterpriseModule'.ts(2305)"

Will leave disabled for now as we only have a few components using one or two interfaces directly from the package.  Not sure if we need this here at all.
*/
// OLD
// import { ModuleRegistry, AllModules } from '@ag-grid-enterprise/all-modules';
// NEW
// import { ModuleRegistry, AllEnterpriseModule } from 'ag-grid-enterprise';

@NgModule({
  declarations: [
    TableComponent,
  ],
  imports: [
    RowModule,
    TableColumnModule,
    AgGridModule,
    TableHeaderModule,
  ],
  exports: [
    AgGridModule,
    TableColumnModule,
    RowModule,
    TableComponent,
  ],
  providers: [
    ColumnFilterFactory,
    TableRowEditAddFactory,
    TableRowEditAutoSaveFactory,
    TableRowEditDeleteFactory,
    TableRowEditFactory,
    TableRowFooterAggregationFactory,
  ],
})
export class GridModule {
  constructor() {
    // ModuleRegistry.registerModules([AllEnterpriseModule]);
  }
}
